import avatar1 from "../assets/images/avatar1.jpg";
import avatar2 from "../assets/images/avatar2.jpg";
import avatar3 from "../assets/images/avatar3.jpg";
import staff1 from "../assets/images/staff-member1.png";
import staff2 from "../assets/images/staff-member2.png";
import staff3 from "../assets/images/staff-member0.png";
import staff4 from "../assets/images/staff-member4.png";
import staff5 from "../assets/images/staff-member5.png";
import staff6 from "../assets/images/staff-member6.png";

export const services = [
  {
    key: 1,
    name: "App Development",
    desc: "Lorem ipsum dolor sit amet consectetur. Lacus ullamcorper blandit ut nisl iaculis. Luctus cras risus viverra netus eu. Urna nunc condimentum tincidunt parturient suspendisse posuere. Libero in id vitae purus quis mattis.",
    icon: "fa-mobile",
  },
  {
    key: 2,
    name: "Web Hosting",
    desc: "Lorem ipsum dolor sit amet consectetur. Lacus ullamcorper blandit ut nisl iaculis. Luctus cras risus viverra netus eu. Urna nunc condimentum tincidunt parturient suspendisse posuere. Libero in id vitae purus quis mattis.",
    icon: "fa-database",
  },
  {
    key: 3,
    name: "Secured System",
    desc: "Lorem ipsum dolor sit amet consectetur. Lacus ullamcorper blandit ut nisl iaculis. Luctus cras risus viverra netus eu. Urna nunc condimentum tincidunt parturient suspendisse posuere. Libero in id vitae purus quis mattis.",
    icon: "fa-lock",
  },
  {
    key: 4,
    name: "Cloud Storage",
    desc: "Lorem ipsum dolor sit amet consectetur. Lacus ullamcorper blandit ut nisl iaculis. Luctus cras risus viverra netus eu. Urna nunc condimentum tincidunt parturient suspendisse posuere. Libero in id vitae purus quis mattis.",
    icon: "fa-computer",
  },
];

export const staffData = [
  {
    id: 1,
    name: "Yisake Abera",
    position: "UI/UX Designer",
    photo: staff1,
  },
  {
    id: 2,
    name: "Nebiyu Yigerem",
    position: "Project Manager",
    photo: staff4,
  },
  {
    id: 3,
    name: "Mena Mengistu",
    position: "Quality Assurance",
    photo: staff5,
  },
  {
    id: 4,
    name: "Hagos Demeke",
    position: "Marketing Officer",
    photo: staff2,
  },
  {
    id: 5,
    name: "Elyas Abebe",
    position: "Full Stack Developer",
    photo: staff3,
  },
  {
    id: 6,
    name: "Lulit Sitotaw",
    position: "Sales Executive",
    photo: staff6,
  },
];

export const features = [
  {
    key: 1,
    feature: "High Security",
    desc: "Lorem ipsum dolor sit amet consectetur. Eget sed feugiat tincidunt blandit pellentesque.",
    icon: "fa-shield",
  },
  {
    key: 2,
    feature: "Accessible Database",
    desc: "Lorem ipsum dolor sit amet consectetur. Eget sed feugiat tincidunt blandit pellentesque.",
    icon: "fa-database",
  },
  {
    key: 3,
    feature: "Customized Features",
    desc: "Lorem ipsum dolor sit amet consectetur. Eget sed feugiat tincidunt blandit pellentesque.",
    icon: "fa-cogs",
  },
  {
    key: 4,
    feature: "Fast Uploading",
    desc: "Lorem ipsum dolor sit amet consectetur. Eget sed feugiat tincidunt blandit pellentesque.",
    icon: "fa-cloud-upload",
  },
  {
    key: 5,
    feature: "Active Server",
    desc: "Lorem ipsum dolor sit amet consectetur. Eget sed feugiat tincidunt blandit pellentesque.",
    icon: "fa-server",
  },
  {
    key: 6,
    feature: "Two Step Verified",
    desc: "Lorem ipsum dolor sit amet consectetur. Eget sed feugiat tincidunt blandit pellentesque.",
    icon: "fa-unlock-alt",
  },
];

export const testomonials = [
  {
    id: 1,
    name: "Ms. Rachel Abate",
    testimony:
      "Lorem ipsum dolor sit amet consectetur. Etiam enim velit vulputate mattis habitasse at. Vel faucibus ac quis et lectus velit at. Nibh ornare suspendisse cras eu mollis tristique netus ac nisi. ",
    possition: "CEO of Fast delivery",
    photo: avatar1,
  },
  {
    id: 2,
    name: "Mr. Edward Walterscott",
    testimony:
      "Lorem ipsum dolor sit amet consectetur. Etiam enim velit vulputate mattis habitasse at. Dignissim odio adipiscing ut adipiscing. Orci diam adipiscing bibendum venenatis fringilla faucibus.",
    possition: "Senior Developer",
    photo: avatar2,
  },
  {
    id: 3,
    name: "Mr. Daniel Samuel",
    testimony:
      "Lorem ipsum dolor sit amet consectetur. Vel faucibus ac quis et lectus velit at. Nibh ornare suspendisse cras eu mollis tristique netus ac nisi. Dignissim odio adipiscing ut adipiscing. Orci diam adipiscing bibendum venenatis.",
    possition: "Manager at Safaricom",
    photo: avatar3,
  },
];

export const pricing_plan = {
  starter: [
    "Basic functionality",
    "Limited storage",
    "Email support",
    "Access to core features",
    "24/7 customer support",
    "Single user license",
    "Standard security measures",
  ],
  pro: [
    "Advanced functionality",
    "Unlimited storage",
    "Priority email and phone support",
    "Access to all features",
    "Multi-user license",
    "Enhanced security measures",
    "Dedicated account manager and onboarding support",
  ],
  premium: [
    "Full suite of advanced functionality",
    "Unlimited storage and bandwidth",
    "Priority email, phone, and chat support",
    "Advanced reporting and analytics with custom dashboards",
    "Integration with enterprise apps and APIs",
    "Dedicated account manager and onboarding support",
    "Service level agreements (SLAs) for uptime and response times",
  ],
};

export const footerListText = {
  about_us: ["About Us", "Contact Us", "Careers", "Our Team"],
  product_and_services: [
    "Solutions",
    "Pricing",
    "Features",
    "Integrations",
    "Demo",
    "Free Trial",
  ],
  privacy_policy: [
    "Terms of Service",
    "Privacy Policy",
    "Cookie Policy",
    "Data Protection",
    "Security Measures",
    "Compliance",
  ],
  related_links: [
    "Case Studies",
    "Blog",
    "Whitepapers",
    "Webinars",
    "eBooks",
    "Video Tutorials",
  ],
};
